import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarCustomComponent } from "./snackbar-custom.component";
import { SnackbarType } from "./snackbar.models";
import { SnackbarNewComponent } from "../snackbar-new/snackbar-new.component";
import { SnackbarNewData } from "../snackbar-new/snackbar-new.models";
@Injectable({
  providedIn: "root",
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  /**
   * New-UI (BCAD-529) snackbar — Ember→Mulberry card with a heading + body and
   * a Doodat illustration.
   */
  openDesignSnackbar(
    heading: string,
    message: string,
    duration: number = 5000
  ) {
    return this.snackBar.openFromComponent(SnackbarNewComponent, {
      duration: duration,
      panelClass: ["snackbar-new-panel"],
      data: { heading, message } as SnackbarNewData,
    });
  }

  openSnackBar(
    message: string,
    duration: number = 5000,
    type: SnackbarType = "error"
  ) {
    this.snackBar.openFromComponent(SnackbarCustomComponent, {
      duration: duration,
      data: {
        message: message,
        type: type,
      },
    });
  }

  /**
   * New-UI snackbar that stays open until manually dismissed via its close icon -
   * omitting `duration` from the MatSnackBar config entirely (rather than passing
   * a large number) is what makes it persistent.
   */
  openPersistentDesignSnackbar(heading: string, message: string) {
    return this.snackBar.openFromComponent(SnackbarNewComponent, {
      panelClass: ["snackbar-new-panel"],
      data: { heading, message } as SnackbarNewData,
    });
  }

  /**
   * New-UI snackbar with an action button (e.g. "Undo").
   */
  openDesignSnackbarWithAction(
    heading: string,
    message: string,
    actionText: string,
    duration: number = 5000
  ) {
    return this.snackBar.openFromComponent(SnackbarNewComponent, {
      duration,
      panelClass: ["snackbar-new-panel"],
      data: { heading, message, actionText } as SnackbarNewData,
    });
  }

  openSnackBarWithAction(
    message: string,
    actionText: string,
    duration: number = 5000,
    type: SnackbarType = "success"
  ) {
    const snackBarRef = this.snackBar.openFromComponent(
      SnackbarCustomComponent,
      {
        duration: duration,
        data: {
          message: message,
          actionText: actionText,
          type: type,
        },
      }
    );

    return snackBarRef;
  }
}
